import {MAP_TOOLTIP_DATA, WINDOW_SIZE, HASH_CHANGE, SELECTED_ITEM, SET_LEGEND_STATE, SET_NAV_STATE, SET_SELECTED_MAP_CONTROL, SET_SWITCH_MAP_CONTROL, SET_NAV_OPEN, SET_SETTINGS_OPEN, SET_STATS_OPEN} from "../actions/SettingsAction";
import {NAV_FIXED_WHERE_SCROLL} from "../helpers/consts";

function getBreakpoint(){
  let breakpoint = 'sm';
  if (window.matchMedia('(max-width: 572px)').matches) {
    breakpoint = 'sm';
  } else if (window.matchMedia('(max-width: 768px)').matches) {
    breakpoint = 'md';
  } else if (window.matchMedia('(max-width: 992px)').matches) {
    breakpoint = 'lg';
  } else if (window.matchMedia('(min-width: 992px)').matches) {
    breakpoint = 'xl';
  }

  return breakpoint;
}

const isBigHeight = window.innerHeight > 712;

const initialState = {
  tooltipData:null,
  tooltipMetadata:null,
  window: {
    width: window.innerWidth,
    height: window.innerHeight,
    breakpoint: getBreakpoint()
  },
  isIE11: /Trident.*rv[ :]*11\./.test(navigator.userAgent),
  selected: null,
  hash:'',
  hashParts:{
    type: '',
    view: '',
    section: ''
  },
  legendOpen: window.innerWidth > 768,
  statsOpen: isBigHeight,
  map:{
    "Clusters": {id: 14, name: "Average EU Cluster", type: "Cluster"},
    "Regions": false,
    "Occupations": {id: 840, name: "Health professionals", type: "ISCO"}
  },
  switch:{
    "perspective":false,
    "measure":false,
    "measure_occ": false,
    "perspective_occ": false,
    "share_occ": false,
    "workers_chart": false
  },
  nav:{
    open:false,
    settings: false,
    fixed: window.scrollY > NAV_FIXED_WHERE_SCROLL ? true : false
  },
  baseUrl: window.FOW_BASE_URL ? window.FOW_BASE_URL : "./"
};
export default (state = initialState, action) => {
  let openValue;
  switch (action.type) {
    case MAP_TOOLTIP_DATA:
      return {
        ...state,
        tooltipData: action.payload.data
      };

    case WINDOW_SIZE:
      return {
        ...state,
        window: {...action.payload, breakpoint: getBreakpoint()}
      };

    case HASH_CHANGE:
      const parts = action.payload.split('/');
      return {
        ...state,
        hash: action.payload,
        hashParts: {
          type: parts[1],
          view: parts[2],
          section: parts[3] ? parts[3]:''
        },
        nav: {
          ...state.nav,
          open: false,
          settings: false
        }
      };

    case SELECTED_ITEM:
      return {
        ...state,
        selected: action.payload
      };

    case SET_LEGEND_STATE:
      openValue = state.statsOpen;
      if (!isBigHeight) {
        openValue = action.payload.open ? false : state.statsOpen;
      }
      return {
        ...state,
        legendOpen: action.payload.open,
        statsOpen: openValue
      };

    case SET_NAV_STATE:
      return {
        ...state,
        nav:{
          ...state.nav,
          fixed: action.payload.fixed
        }
      }

    case SET_SELECTED_MAP_CONTROL:
      let tempMap = {
        ...state.map,
        [action.payload.group]: action.payload.item
      };
      if (action.payload.clearGroup){
        tempMap[action.payload.clearGroup] = false;
      }
      return {
        ...state,
        map:tempMap,
      }

    case SET_SWITCH_MAP_CONTROL:
      return {
        ...state,
        switch: {
          ...state.switch,
          [action.payload.group]: action.payload.item
        },
        nav: {
          ...state.nav,
          settings: false
        }
      }

    case SET_NAV_OPEN:
      return {
        ...state,
        nav: {
          ...state.nav,
          open: action.payload.open
        }
      }

    case SET_SETTINGS_OPEN:
      return {
        ...state,
        nav: {
          ...state.nav,
          settings: action.payload.open
        }
      }

    case SET_STATS_OPEN:
      openValue = state.legendOpen;
      if (!isBigHeight){
        openValue = action.payload.open ? false : state.legendOpen;
      }
      return {
        ...state,
        statsOpen: action.payload.open,
        legendOpen: openValue
      };

    default:
      return state;
  }
};
